import { commonThemeOptions } from '@modules/theme/constants';
import { createTheme, Theme } from '@mui/material';
import type {} from '@mui/x-data-grid/themeAugmentation';

const DARK_DRAWER_BG = '#272632';

export const darkTheme: Theme = createTheme({
  ...commonThemeOptions,
  mixins: {
    MuiDataGrid: {
      // Pinned columns sections
      pinnedBackground: 'rgb(18, 18, 29)',
      // Headers, and top & bottom fixed rows
      containerBackground: '#171623',
    },
  },
  components: {
    ...commonThemeOptions.components,
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: DARK_DRAWER_BG,
          backgroundImage: 'none',
        },
      },
    },
  },
  palette: {
    mode: 'dark',
    primary: {
      main: '#BFC2FF',
      light: '#F2F5FF',
      contrastText: '#0300AD',
      dark: '#8E92CC',
    },
    secondary: {
      main: '#DBB8FF',
      light: '#FFEAFF',
      dark: '#A988CC',
      contrastText: '#460086',
    },
    background: {
      default: '#12121D',
      paper: '#171623',
    },
    error: {
      main: '#F44336',
      light: '#E57373',
      dark: '#D32F2F',
      contrastText: '#FFFFFF',
    },
    warning: {
      main: '#FFA726',
      light: '#FFB74D',
      dark: '#F57C00',
      contrastText: 'rgba(0,0,0,0.87)',
      A100: 'rgba(255, 167, 38, 0.08)',
    },
    info: {
      main: '#29B6F6',
      light: '#4FC3F7',
      dark: '#0288D1',
      contrastText: 'rgba(0,0,0,0.87)',
      A100: '#01a9f4',
    },
    success: {
      main: '#66BB6A',
      light: '#81C784',
      dark: '#388E3C',
      contrastText: 'rgba(0,0,0,0.87)',
    },
    text: {
      primary: '#FFFFFF',
      secondary: 'rgba(255,255,255,0.7)',
      disabled: 'rgba(255,255,255,0.4)',
    },
    sentiment: {
      negative: '#AD2F34',
      neutral: '#7D5800',
      positive: '#006E23',
    },
    feedback: {
      chatBubble: {
        primary: '#3F3F58',
        secondary: '#2A2935',
      },
      audioPlayer: '#31303B',
      summaryCard: '#31303B',
      previewBg: '#262533',
      saved: '#2A2223',
      label: '#ba68c8',
      userMessage: {
        text: '#E1BEE7',
        iconBg: '#521F90',
      },
      cardHoverBg: '#21212a',
    },
    category: {
      complaint: '#EF5350',
      improvement: '#FFA726',
      praise: '#66BB6A',
      help: '#29B6F6',
    },
    misc: {
      hotKey: {
        primary: 'rgba(142, 146, 204, 0.5)',
        disabled: 'rgba(255, 255, 255, 0.12)',
      },
      drawer: {
        background: DARK_DRAWER_BG,
      },
      integrations: {
        user: '#4db6ab',
        account: '#fcb4af',
      },
      wisdom: {
        summary: {
          borderColor: 'rgba(203, 77, 245, 0.58)',
        },
      },
      queryBuilder: {
        dashboardFilter: {
          bgColor: '#040404',
        },
      },
    },
  },
});
